import { orchestrator } from 'satcheljs';
import { removeLocationsFromCommonWell, updateLocations } from 'owa-calendar-compose-form-actions';
import { removeLocationMetrics } from 'owa-calendar-compose-form-store/lib/mutators/eventMetricsMutators';
import { getComposeStore } from 'owa-calendar-compose-store-manager';

export default orchestrator(removeLocationsFromCommonWell, actionMessage => {
    const removedLocations = actionMessage.removedLocations;

    const { event } = getComposeStore();
    // filter locations
    const locations = event.Locations.filter(
        location =>
            !removedLocations.some(
                removedLocation => removedLocation.persona.personaId === location.Id
            )
    );

    updateLocations(locations);
    removeLocationMetrics(
        removedLocations.map(removedLocation => removedLocation.persona.personaId)
    );
});
